import React, {MouseEvent} from 'react'

import Icon from "react-icons-kit/Icon";
import {infoCircle} from "react-icons-kit/fa/infoCircle";

import clsx from 'clsx'
import { ls } from '../../../locale'

export function FareLabels() {
  
  const rFareRule = ls.t('FareRule')
  
  return (
    <div className={clsx('tw-hidden',
      'md:tw-grid md:tw-grid-rows-subgrid md:tw-row-span-12'
    )}>
      <div></div>
      <FareItemBox><FareLabel label={rFareRule.HandLuggage.Label} notes={rFareRule.HandLuggage.Notes} icon='handbag' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CarryOnLuggage.Label}  notes={rFareRule.CarryOnLuggage.Notes} icon='carryon' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CheckInLuggage.Label} notes={rFareRule.CheckInLuggage.Notes} icon='checkedbag' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.PriorityCheckin.Label} notes={rFareRule.PriorityCheckin.Notes} icon='priority' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.Seat.Label} notes={rFareRule.Seat.Notes} icon='seat' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.Meal.Label} notes={rFareRule.Meal.Notes} icon='meal' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.OnlineCheckin.Label} notes={rFareRule.OnlineCheckin.Notes} icon='online' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CounterCheckin.Label} notes={rFareRule.CounterCheckin.Notes} icon='counter' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.ChangeFlight.Label} notes={rFareRule.ChangeFlight.Notes} icon='change' /></FareItemBox>
      <FareItemBox><FareLabel label={rFareRule.CancelFlight.Label} notes={rFareRule.CancelFlight.Notes} icon='cancellation' /></FareItemBox>
      <div></div>
    </div>
  )
}

export function FareItemBox({hideBottomLineInMobile = false, children}: {hideBottomLineInMobile?: boolean, children?: React.ReactNode}) {
  return (
    <div className='tw-px-1 tw-flex tw-items-stretch'>
      <div className={clsx('tw-w-full tw-py-2',
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-solid tw-border-0 tw-border-gray-200',
        hideBottomLineInMobile ? 'md:tw-border-b ' : 'tw-border-b'
      )}>
        {children}
      </div>
    </div>
  )
}

export function FareItemDetail({ label, notes, icon, children }: { label: string, notes?: string, icon: string, children: string | React.ReactNode }) {
  return (
    <div className='tw-w-full tw-flex tw-justify-between md:tw-block'>
      <div className='tw-grow md:tw-hidden'>
        <FareLabel label={label} notes={notes} icon={icon} />
      </div>
      <div className='tw-flex tw-justify-center tw-items-center'>
        <FareItemValue>{children}</FareItemValue>
      </div>
    </div>
  )
}

const handleTooltipClick = (e:MouseEvent<HTMLButtonElement>) => e.stopPropagation();

export function FareItemDetailWithInfo({label, notes, icon, tooltipId, children}: {tooltipId: string, label: string, notes?: string, icon: string, children: string | React.ReactNode}) {

  return (
    <div className='tw-w-full tw-flex tw-justify-between md:tw-block'>
      <div className='tw-grow md:tw-hidden'>
        <FareLabel label={label} notes={notes} icon={icon} />
      </div>
      { !children || children === 'X' 
        ?<FareItemValue>{children}</FareItemValue>
        : <div className='tw-flex tw-justify-center tw-items-center tw-gap-1 tw-pe-2'>
            <span className='tw-text-start'><FareItemValue>{children}</FareItemValue></span>
            <span><Icon icon={infoCircle} data-tip data-tooltip-id={tooltipId} data-type="error" onClick={handleTooltipClick}/></span>
          </div>
      }
    </div>
  )
}

function FareLabel({ label, notes, icon }: { label: string, notes?: string, icon: string }) {
  return (
    <div className='tw-w-full tw-flex tw-justify-start tw-items-center tw-gap-1 tw-text-[12px]'>
      <i className={`picon picon-${icon}`} />
      <div className='tw-flex tw-flex-col'>
        <div className='tw-text-start tw-font-semibold tw-text-[13px]'>{label}</div>
        {notes && <div className='tw-text-start tw-text-gray-400'> ({notes})</div>}
      </div>
    </div>
  )
}


function FareItemValue({children}: {children: string | React.ReactNode}) {
  if(!children) return <i className="picon picon-cross"/>;
  if(typeof children !== 'string') return children;

  return (!children.trim() || children === 'X') ? <i className="picon picon-cross"/> : <div className='tw-pe-2'>{children}</div>
}
